import React from "react";
import "./neighborhood.scss";

const Neighborhood = () => {
	return (
		<div className="neighborhood-section">

			<div className="header-map-link">
				<h2 className="Neighborhood-section-title">Location</h2>
				<a
					className="map-link"
					href="https://maps.app.goo.gl/L6oShtJXYd4SQqDC8"
					target="_blank"
					rel="noopener noreferrer"
				>
					Open in Maps ↗
				</a>
			</div>

			<div className="map-container">

				{/* ✅ GOOGLE MAP */}
				<iframe
					title="Refresh Inn Touch Wood Location Map"
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.544108687257!2d75.90447!3d17.617048200000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc5d996df8cc59f%3A0xc0cd9b162c3ceaf6!2sRefresh%20Inn%20Touch%20Wood!5e1!3m2!1sen!2sin!4v1774763476750!5m2!1sen!2sin"
					width="100%"
					height="650px"
					style={{ border: 0 }}
					allowFullScreen
					loading="lazy"
					referrerPolicy="no-referrer-when-downgrade"
				/>

				{/* OPTIONAL CUSTOM PIN */}
				<div className="pin-location">
					<div className="pin-label">Saiful</div>
					<div className="pin-marker"></div>
				</div>

				{/* INFO PANEL */}
				<div className="location-details-panel">
					<p className="location-address"> Hattur, Bijapur road, Solapur, Maharashtra, India</p>
					{/*<p className="location-drive-time">12 min drive to Nobu Malibu</p>*/}
				</div>

			</div>
		</div>
	);
};

export default Neighborhood;